import type { Order, OrderStatus } from '../types';
import { matches, parseQuery } from './search';

export const UNASSIGNED_TECHNICIAN_VALUE = 'unassigned';
export const TERMINAL_ORDER_STATUSES: OrderStatus[] = ['COMPLETED', 'CANCELLED'];

// Общий фильтр по сантехнику + поиску, переиспользуется в Списке/Канбане/Календаре —
// чтобы во всех трёх видах "Все сантехники"/поиск работали одинаково
export function filterOrders(orders: Order[], technicianId: string, search: string): Order[] {
  let result = orders;

  if (technicianId === UNASSIGNED_TECHNICIAN_VALUE) {
    result = result.filter((o) => !o.technicianId);
  } else if (technicianId) {
    result = result.filter((o) => o.technicianId === technicianId);
  }

  // Номер наряда, сантехник и организация добавились вместе с общим поиском: наряд
  // ищут по номеру из Битрикса чаще, чем по адресу, а раньше номер не искался вовсе
  const query = parseQuery(search);
  if (query) {
    result = result.filter((o) =>
      matches(query, [
        o.orderNumber,
        o.address,
        o.clientName,
        o.clientPhone,
        o.description,
        o.technician?.fullName,
        o.companyName,
      ]),
    );
  }

  return result;
}
